import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { Local } from 'protractor/built/driverProviders';
import { ApiMethod } from '../apimethods/api-method';
import { DataParam, customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { weightageUserReportModel } from './weightage-userReportmodel';

declare var $;


@Component({
  selector: 'app-weightage-userReport',
  templateUrl: './weightage-userReport.component.html',
  styleUrls: ['./weightage-userReport.component.css']
})
export class weightageUserReportComponent implements OnInit {

  modelItem = new weightageUserReportModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
    DepartmentsList: any;
    UsersList: any;
    BUHeadList: any;


  ngOnInit() {


  }

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <weightageUserReportModel>data["weightageUserReportPage"];


        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");

        $('#ddlBUHeadList').select2({
          placeholder: "Select BUHead",
          dropdownParent: "#divMainFilter"
        });
        $('#ddlBUHeadList').val([]).trigger('change');

        $('#ddlDepartmentList').select2({
          placeholder: "Select Department",
          dropdownParent: "#divMainFilter"
        });
        $('#ddlDepartmentList').val([]).trigger('change');

        $('#ddlUsersList').select2({
          placeholder: "Select User",
          dropdownParent: "#divMainFilter"
        });
        $('#ddlUsersList').val([]).trigger('change');

       
        this.GetweightageuserReportMastersData();
        this.GetAllBUHeadListAPI();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  GetAllBUHeadListAPI(): void {
    ApiMethod.getMethod(this.modelItem.GetAllBUHeadListAPI).subscribe(
      result => {
        this.BUHeadList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  DepartmentsListByBUHead(): void {
    var BUHead = $("#ddlBUHeadList").val().toString();
    ApiMethod.getMethod(this.modelItem.DepartmentsListByBUHeadAPI + BUHead).subscribe(
      result => {
        this.DepartmentsList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  UsersListByBUHeadAndDepartmentList(): void {
    var BUHead = $("#ddlBUHeadList").val().toString();
    var Department = $("#ddlDepartmentList").val().toString();
    ApiMethod.getMethod(this.modelItem.UsersListByBUHeadAndDepartmentListAPI + BUHead + '/' + Department).subscribe(
      result => {
        this.UsersList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }



  GetweightageuserReportMastersData(): void {

    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      UserID: $("#ddlUsersList").val().toString(),
      BUheadID: $("#ddlBUHeadList").val().toString(),
      DepartmentID: $("#ddlDepartmentList").val().toString(),
      ApprovedStatus: $("#ddlApprovedStatus").val(),
      FromDate: $("#Txt_FromDate").val(),
      ToDate: $("#Txt_ToDate").val(),
      ModuleName: "WeightageUserReportModule"
    }
    ApiMethod.postMethod(this.modelItem.GetWeightageUserReportAPI, dataParam).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 210);
        dataItem.modulename = 'WeightageUserReportModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable


        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }
  resetFilter() {
    $("#ddlUsersList").val(0).change();
    $("#ddlDepartmentList").val(0).change();
    $("#ddlBUHeadList").val(0).change();
    $("#ddlApprovedStatus").val(0).change();
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    this.GetweightageuserReportMastersData();
  }


}

